import { Recurso } from "lib.common/dist/CleanArch";
import { ClientesTiendaDtSource } from "../../bussines/dataSources/ClientesTiendaDtSource";
import { ClientesTiendaRepository } from "../../bussines/repositories/ClientesTiendaRepository";
import { ClienteTiendaModel } from "../models/ClienteTiendaModel";
import { ErrDevValidacion } from "lib.common/dist/errorHandler";

export class ClientesTiendaRepositoryImpl implements ClientesTiendaRepository<ClienteTiendaModel> {
    private dataSource: ClientesTiendaDtSource;
    constructor(dataSource: ClientesTiendaDtSource) {
        this.dataSource = dataSource;
    }

    async getAllClientesTienda(): Promise<Recurso<ClienteTiendaModel[]>> {
        try {
            const result = await this.dataSource.getAllClientesTienda();

            if (result.isSuccess()) {
                return Recurso.fromData<ClienteTiendaModel[]>(
                    result.data!.map(ClienteTiendaModel.deserialize)
                );
            }
            return Recurso.fromError<ClienteTiendaModel[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<ClienteTiendaModel[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
}